import { TimePickerProps, TimePicker as AntdTimePicker } from "antd";
import moment from "moment";
import React, { useState } from "react";
import styled from "styled-components";
import { ReactComponent as Cancel } from "../../../assets/icons/TimepickerCancel.svg";
import { ReactComponent as Suffix } from "../../../assets/icons/TimepickerSuffix.svg";
import { TimeMode } from "../../../pages/ReservationConfig/Interface";
import { theme } from "../../../theme";
import Button from "../Button";

interface CustomTimePickerProps extends TimePickerProps {
  onOk?: (e?: moment.Moment) => void;
  type?: TimeMode;
  startHour?: number;
  endHour?: number;
}
const TimePicker: React.FC<CustomTimePickerProps> = (props) => {
  const {
    onOk = () => {},
    value,
    disabledTime,
    type,
    startHour,
    endHour,
    ...rest
  } = props;
  const [isOpen, setOpen] = useState(false);
  const [time, setTime] = useState<moment.Moment | undefined | null>(value);

  return (
    <StyledTimePicker
      {...props}
      popupStyle={{ minWidth: "300px" }}
      open={isOpen}
      allowClear
      clearIcon={
        <Cancel
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onOk(undefined);
          }}
        />
      }
      suffixIcon={<Suffix />}
      onClick={() => {
        setOpen(!isOpen);
      }}
      inputReadOnly
      panelRender={(origin) => <CustomPanel>{origin}</CustomPanel>}
      onSelect={(value) => {
        if (value) setTime(value);
        switch (type) {
          case TimeMode.END:
            if (value.hours() === startHour) setTime(value.minutes(30));
            break;
          default:
            if (value.hours() === endHour) setTime(value.minutes(0));
            break;
        }
      }}
      renderExtraFooter={() => (
        <StyledFooterWrapper>
          <StyledTimeSpan>{time?.format("HH:mm")} </StyledTimeSpan>
          <Button
            size="small"
            onClick={() => {
              setOpen(false);
              if (onOk && time) onOk(time);
            }}
          >
            확인
          </Button>
        </StyledFooterWrapper>
      )}
      onChange={(value) => {
        if (value === null) onOk(undefined);

        setTime(value);
      }}
      disabledTime={
        disabledTime
          ? (date) => {
              return {
                disabledHours: disabledTime(date)?.disabledHours,
                disabledMinutes: (hour) => {
                  if (hour === -1) return [0, 30];
                  switch (type) {
                    case TimeMode.END:
                      if (hour === startHour) return [0];
                      return [];
                    default:
                      if (hour === endHour) return [30];
                      return [];
                  }
                },
              };
            }
          : undefined
      }
      onBlur={() => {
        setOpen(false);
        setTime(value);
      }}
      {...rest}
    />
  );
};
TimePicker.defaultProps = {
  style: { width: "100%", height: "32px" },
  size: "middle",
  placeholder: "시간 선택",
  minuteStep: 30,
  format: "HH:mm",
  showNow: false,
  placement: "bottomLeft",
};
const StyledTimePicker = styled(AntdTimePicker)`
  .ant-picker-clear {
    background-color: white;
  }
  .ant-picker-suffix {
    margin-left: 0px;
  }
  input::placeholder {
    color: ${theme.colors.gray6};
  }
`;
const StyledTimeSpan = styled.span`
  ${theme.typo.heading.b14};
`;
const StyledFooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  width: 100%;
`;
const CustomPanel = styled.div`
  position: relative;
  .ant-picker-ranges {
    display: none;
  }
  .ant-picker-panel {
    width: 100%;
  }
  .ant-picker-content:nth-child(2) {
    display: none;
  }
`;
export default TimePicker;
